export default "__VITE_ASSET__BHnB4UGF__"